<template>
    <div>
        <h2 v-if="this.$route.path != '/livefacebook'">{{ title }}</h2>
        <apexchart height="500px" type="line" :options="chartOptions" :series="data"></apexchart>
    </div>
</template>

<script>
export default {
    props: ['data', 'headings', 'title'],
    data: () => ({
        chartOptions: {
            chart: {
                height: 500,
                type: 'line',
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            grid: {
                row: {
                    colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                    opacity: 0.5
                },
            },
            xaxis: {
                categories: [],
            }
        },
    }),
    onMounted() {
        this.chartOptions.xaxis.categories = this.headings
        //console.log('this.chartOptions.xaxis.categories', this.chartOptions.xaxis.categories)
    }
}
</script>